export * from "./ShelfEntities"
export * from "./regions"
export const toBoolean = string => string === true || string === "true"
export const formatPrice = float => (float ? `CHF ${float.toFixed(2)}` : "n/a")

export function formatOptionalNumber(value) {
  return value != null ? String(value) : ""
}



// WEBPACK FOOTER //
// ./src/utils/index.js